import { BrowserTracing } from '@sentry/tracing'

export const SENTRY_COMMON_ERROR_IGNORE_LIST = [
  'EncodingError: Unable to decode audio data',
  'EncodingError: Decoding failed',
  'TypeError: Load failed',
  'TypeError: Failed to fetch',
  'TypeError: NetworkError when attempting to fetch resource.',
  'TypeError: cancelled',
  'TypeError: Cancelled',
  'message: cancelled',
  'Decoding failed',
  'Unable to decode audio data',
  'cancelled',
  'ResizeObserver loop limit exceeded',
  'Receiving end does not exist',
  'privateSpecialRepair is not defined',
  'Cannot access a chrome:// URL',
  'Cannot access a chrome-extension:// URL of different extension',
  'Non-Error promise rejection captured with keys: currentTarget, detail, isTrusted, target'
]

export function sentryEnrichEvent(originalException) {
  const extra = {}
  if (originalException.message) {
    extra.message = originalException.message
  }
  if (originalException.config) {
    extra.config = originalException.config
  }
  if (originalException.request) {
    extra.request = originalException.request
  }
  if (originalException.response) {
    extra.response = originalException.response
  }

  return extra
}

export function getSentryConfig(options = {}) {
  return {
    dsn: options.dsn,
    sampleRate: options.sampleRate || 0.1,
    tracesSampleRate: options.tracesSampleRate || 0.1,
    integrations: [new BrowserTracing()],
    enabled: process.env.NODE_ENV === 'production',
    release: options.release,
    ignoreErrors: [
      ...SENTRY_COMMON_ERROR_IGNORE_LIST,
      ...(options.ignoreErrors || [])
    ],
    beforeSend(event, hint) {
      if (hint?.originalException) {
        if (event) {
          event.extra = Object.assign(
            {},
            event.extra ?? {},
            sentryEnrichEvent(hint.originalException)
          )
        }
      }

      if (event?.exception?.values?.length === 1) {
        const [exception] = event.exception.values
        if (
          exception.type === 'UnhandledRejection' &&
          exception.value.includes('Object Not Found Matching Id')
        ) {
          return null
        }
      }

      return event
    }
  }
}
